import { render, staticRenderFns } from "./ProjectTestMode.vue?vue&type=template&id=1179c3d0"
import script from "./ProjectTestMode.vue?vue&type=script&lang=js"
export * from "./ProjectTestMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports